import { Form, Tooltip } from 'antd';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalComponent from '@components/common/Modal';
import { getUsersTechnician } from '@slice/select.slice';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { SetProductMixData } from '@pages/OrganizedSales/CreateOrders/store';
import { getDetailOfOrder } from '@slice/orderManager.slice';
import { IoMdRefreshCircle } from 'react-icons/io';
import Loading from '@components/common/Loading';
import { getAllHandleError, getAllRegularWeak } from '@slice/production.slice';

const UpdateOrders = React.lazy(() => import('@pages/OrganizedSales/CreateOrders/common/UpdateOrders'));
interface IUpdateOrder {
  isOpen: boolean;
  type?: string;
  callBackClose: () => any;
  callBackRefresh?: () => any; // hiện không cần dùng
  callBackUpdate?: (any) => any; // hiện không cần dùng
}

export default function UpdateOrderModal(props: IUpdateOrder) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  const loadedData = useSelector((state: RootState) => state.select.loadedData);
  const productCategoryPMP = useSelector((state: RootState) => state.createOrder.listProductMixDataPaging);
  const [reloadCount, setReloadCount] = useState<number>(0);

  const handleCancel = () => {
    props.callBackClose();
  };

  const callBackCloseModal = () => {
    props.callBackClose();
  };

  useEffect(() => {
    !loadedData.techStaffLoaded && dispatch(getUsersTechnician());
  }, []);

  useEffect(() => {
    SetProductMixData(productCategoryPMP);
  }, [productCategoryPMP]);

  const titleOrder = useMemo(() => {
    return (
      <div className="inline-flex items-center space-x-1">
        <div> {t('OrganizedSales.OrderManager.ModifyOrder.Title') + ' ' + (rowSelected?.maDonHang || '')}</div>

        <Tooltip placement="topLeft" title={t('OrganizedSales.OrderManager.ModalUpdate.ReLoadAOrder')}>
          <span
            className="cursor-pointer"
            onClick={() => {
              dispatch(getDetailOfOrder({ maDonHang: rowSelected?.maDonHang, typeOrder: +rowSelected?.orderType.id }));
              setReloadCount(c => c + 1);
              dispatch(getAllHandleError());
              dispatch(getAllRegularWeak());
            }}
          >
            <IoMdRefreshCircle className="text-gray-400 hover:text-blue-500" size={21} />
          </span>
        </Tooltip>
      </div>
    );
  }, [rowSelected?.maDonHang]);

  return (
    <>
      <ModalComponent
        modalTitle={titleOrder}
        modalType="update"
        modalSize="fullscreen"
        visible={props.isOpen}
        // onOk={form.submit}
        hiddenFooter={true}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <Suspense fallback={<Loading />}>
          <UpdateOrders
            form={form}
            type={props.type}
            setConfirmLoading={value => setConfirmLoading(value)}
            callBackCloseModal={callBackCloseModal}
            callBackLoading={setConfirmLoading}
            //
            reloadCount={reloadCount}
          />
        </Suspense>
      </ModalComponent>
    </>
  );
}
